<template>
  <AppHeader>
    <template #navigation>
      <nuxt-link
        :to="localePath('/operator/requests')"
        exact
      >
        <el-popover
          placement="bottom"
          width="750"
          trigger="hover"
          :visible-arrow="false"
          popper-class="HeaderNavigationItemPopover shadow-base rounded-xs max-w-full border-none"
          :disabled="pendingRequests.length === 0"
        >
          <OperatorAppHeaderRequests
            v-loading="isPendingRequestsLoading"
            :requests="pendingRequests"
          />

          <template #reference>
            <div
              class="h-12 flex items-center"
              @mouseenter="loadPendingRequests"
            >
              Požadavky

              <el-badge
                v-if="pendingRequests.length > 0"
                :value="pendingRequests.length"
                :max="99"
                class="absolute ml-1 left-full top-1/2 -translate-y-1/2"
                type="danger"
              />
            </div>
          </template>
        </el-popover>
      </nuxt-link>
      <nuxt-link :to="localePath('/operator/users/clients')">
        Klienti
      </nuxt-link>
      <nuxt-link
        v-if="useAuthStore().user.lang !== 'ua'"
        :to="localePath('/operator/users/organizations')"
      >
        Organizace
      </nuxt-link>
      <nuxt-link :to="localePath('/operator/users/operators')">
        Tlumočníci
      </nuxt-link>
      <nuxt-link :to="localePath('/operator/shifts')">
        Služby
      </nuxt-link>
    </template>
    <template #right>
      <el-button
        v-if="useAuthStore().user?.lang !== 'ua'"
        circle
        plain
        class="border-none bg-white/20 hover:bg-white/30 text-white"
        @click="$store.dispatch('chat/openChat', {
          room_id: 1,
        })"
      >
        <icon-chat />
      </el-button>

      <OperatorAppHeaderCall
        v-if="useAuthStore().user?.lang !== 'ua'"
        class="ml-4"
      />
    </template>
  </AppHeader>
</template>

<script setup>
// Refs
const isPendingRequestsLoading = ref(false);

// Computed
const pendingRequests = computed(() => useNuxtApp().$store.state.operator.requests.pendingRequests);
const localePath = useLocalePath();

// Methods
const loadPendingRequests = async() => {
  isPendingRequestsLoading.value = true;
  await useNuxtApp().$store.dispatch('operator/requests/getPendingRequests');
  isPendingRequestsLoading.value = false;
};

// Lifecycle
onMounted(() => {
  loadPendingRequests();
});
</script>
